<div class="d-flex flex-column gap-2">
    @for (message of messages() | sort: 'createdAt'; track message.messageId) {
        <div class="d-flex flex-column w-100">
            <div class="font-sm weight-light">
                From:&nbsp;{{ messageFrom(message) }}
            </div>
            <div class="font-sm weight-light">
                To:&nbsp;{{ messageTo(message) }}
            </div>
            <div class="mt-3 mb-3 font-md weight-medium">
                {{ message.subject }}
            </div>
            <div
                class="w-100"
                [innerHTML]="messageBody(message) | unsafe"
            ></div>
        </div>
    }
</div>
